"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var LogoutLink_1 = __importDefault(require("./LogoutLink"));
var Counter_1 = __importDefault(require("../common/Counter"));
var BizTag_1 = __importDefault(require("./BizTag"));
var ui_1 = require("@aperza/ui");
var TdLink_1 = __importDefault(require("../common/TdLink"));
var util_1 = require("@aperza/util");
var appConfig = util_1.AppService.appConfig();
var react_aim_1 = require("react-aim");
// @ts-ignore
var UserMenuList = /** @class */ (function (_super) {
    __extends(UserMenuList, _super);
    function UserMenuList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserMenuList.prototype.render = function () {
        var viewer = this.props.viewer;
        return (react_1.default.createElement("div", { className: "userMenuList" },
            react_1.default.createElement("div", { className: "userName" },
                react_1.default.createElement(TdLink_1.default, { action: "usermenu_mytop", href: "https://account" + appConfig.baseComDomain + "/", anchorMessageId: "userMenu.name", anchorMessageValue: { name: viewer.displayName } },
                    react_1.default.createElement("p", { className: "name" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.name", values: { name: viewer.displayName } }))),
                viewer.isBusiness && viewer.companyName && (react_1.default.createElement("p", { className: "company" }, viewer.companyName))),
            react_1.default.createElement("div", { className: "menuList" },
                react_1.default.createElement(TdLink_1.default, { className: "menuItem td-click", action: "usermenu_clip", href: "https://account" + appConfig.baseComDomain + "/clip", anchorMessageId: "userMenu.clip.title" },
                    react_1.default.createElement("p", { className: "title" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.clip.title" })),
                    react_1.default.createElement("p", { className: "caption" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.clip.caption" }))),
                react_1.default.createElement(TdLink_1.default, { className: "menuItem td-click", action: "usermenu_history", href: "https://account" + appConfig.baseComDomain + "/history", anchorMessageId: "userMenu.history.title" },
                    react_1.default.createElement("p", { className: "title" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.history.title" })),
                    react_1.default.createElement("p", { className: "caption" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.history.caption" }))),
                react_1.default.createElement(TdLink_1.default, { className: "menuItem td-click", action: "usermenu_mail", href: "https://account" + appConfig.baseComDomain + "/mail", anchorMessageId: "userMenu.mail.title" },
                    react_1.default.createElement("p", { className: "title" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.mail.title" })),
                    react_1.default.createElement("p", { className: "caption" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.mail.caption" }))),
                react_1.default.createElement(TdLink_1.default, { className: "menuItem td-click", action: "usermenu_account", href: "https://account" + appConfig.baseComDomain + "/account", anchorMessageId: "userMenu.account.title" },
                    react_1.default.createElement("p", { className: "title" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.account.title" })),
                    react_1.default.createElement("p", { className: "caption" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.account.caption" }))),
                react_1.default.createElement(TdLink_1.default, { className: "menuItem td-click", action: "usermenu_message", href: "https://" + appConfig.baseCluezMemberDomain + "/" + viewer.locale + "/message/list", anchorMessageId: "userMenu.message.title", openOnNewTab: true },
                    react_1.default.createElement("p", { className: "title" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.message.title" }),
                        "\u00A0",
                        viewer.unreadMessageCount > 0 && react_1.default.createElement(Counter_1.default, { count: viewer.unreadMessageCount })),
                    react_1.default.createElement("p", { className: "caption" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.message.caption" }))),
                viewer.isBusiness && (react_1.default.createElement(TdLink_1.default, { className: "menuItem td-click", action: "usermenu_biz", href: "https://cloud" + appConfig.baseComDomain + "/home/index.html", anchorMessageId: "userMenu.marketing.title" },
                    react_1.default.createElement("p", { className: "title" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.marketing.title" }),
                        "\u00A0",
                        react_1.default.createElement(BizTag_1.default, null)),
                    react_1.default.createElement("p", { className: "caption" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.marketing.caption" })))),
                viewer.isActiveBusiness && (react_1.default.createElement(TdLink_1.default, { className: "menuItem td-click", action: "usermenu_biz", href: "https://business" + appConfig.baseComDomain + "/f/order/index.html", anchorMessageId: "userMenu.bizAccount.title" },
                    react_1.default.createElement("p", { className: "title" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.bizAccount.title" }),
                        "\u00A0",
                        react_1.default.createElement(BizTag_1.default, null)),
                    react_1.default.createElement("p", { className: "caption" },
                        react_1.default.createElement(ui_1.Message, { messageId: "userMenu.bizAccount.caption" }))))),
            react_1.default.createElement(LogoutLink_1.default, null)));
    };
    UserMenuList.propTypes = {
        viewer: prop_types_1.default.any.isRequired,
    };
    UserMenuList = __decorate([
        react_aim_1.target()
    ], UserMenuList);
    return UserMenuList;
}(react_1.default.Component));
exports.default = UserMenuList;
